const A = "avatar_panel", O = "ADMIN";
export {
  O as ADMIN_ROLE,
  A as PARTOOROBOT_AVATAR_PANEL
};
